<script>
  let { assetsPath = '/', onAiMounted = () => {} } = $props();
  import { onMount } from 'svelte';
  onMount(() => {
    onAiMounted();
  });
</script>

<div id="g-p3_irgc-ghadir-box">
  <!-- Artboard: xs -->
  <div
    id="g-p3_irgc-ghadir-xs"
    class="g-artboard"
    style="display: none;aspect-ratio: 0.81885856079404;"
  >
    <div
      id="g-p3_irgc-ghadir-xs-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_irgc-ghadir-xs.jpg);"
    ></div>
    <div
      id="g-ai0-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:2.0052%;margin-top:-11.1px;left:0%;width:181px;"
    >
      <p class="g-pstyle0">IRGC Ghadir site in Tehran</p>
    </div>
    <div
      id="g-ai0-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:14.2675%;margin-top:-7.5px;left:16.7341%;width:56px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:19.2303%;margin-top:-7.5px;left:17.5049%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:19.9747%;margin-top:-7.5px;left:54.5629%;margin-left:-57px;width:114px;"
    >
      <p class="g-pstyle3">Building damaged</p>
    </div>
  </div>

  <!-- Artboard: sm -->
  <div
    id="g-p3_irgc-ghadir-sm"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.08742004264392;"
  >
    <div
      id="g-p3_irgc-ghadir-sm-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_irgc-ghadir-sm.jpg);"
    ></div>
    <div
      id="g-ai1-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.954%;margin-top:-11.2px;left:0%;width:204px;"
    >
      <p class="g-pstyle0">IRGC Ghadir site in Tehran</p>
    </div>
    <div
      id="g-ai1-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:12.4729%;margin-top:-7.5px;left:11.1875%;width:56px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.5241%;margin-top:-7.5px;left:11.6497%;margin-left:-28px;width:56px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:19.296%;margin-top:-7.5px;left:41.4861%;margin-left:-57px;width:114px;"
    >
      <p class="g-pstyle3">Building damaged</p>
    </div>
  </div>

  <!-- Artboard: md -->
  <div
    id="g-p3_irgc-ghadir-md"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.08731466227348;"
  >
    <div
      id="g-p3_irgc-ghadir-md-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_irgc-ghadir-md.jpg);"
    ></div>
    <div
      id="g-ai2-1"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:1.8665%;margin-top:-11.3px;left:0%;width:249px;"
    >
      <p class="g-pstyle0">IRGC Ghadir site in Tehran</p>
    </div>
    <div
      id="g-ai2-2"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:12.2045%;margin-top:-9.1px;left:11.1954%;width:62px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:16.1583%;margin-top:-9.1px;left:11.6829%;margin-left:-31px;width:62px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-artwork g-aiAbs g-aiPointText"
      style="top:19.1237%;margin-top:-9.1px;left:41.6172%;margin-left:-65px;width:130px;"
    >
      <p class="g-pstyle3">Building damaged</p>
    </div>
  </div>

  <!-- Artboard: lg -->
  <div
    id="g-p3_irgc-ghadir-lg"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.5;"
  >
    <div
      id="g-p3_irgc-ghadir-lg-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_irgc-ghadir-lg.jpg);"
    ></div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:40.3873%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:40.3873%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:40.3873%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
  </div>

  <!-- Artboard: xl -->
  <div
    id="g-p3_irgc-ghadir-xl"
    class="g-artboard"
    style="display: none;aspect-ratio: 1.93548387096774;"
  >
    <div
      id="g-p3_irgc-ghadir-xl-img"
      class="g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/p3_irgc-ghadir-xl.jpg);"
    ></div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
  </div>
</div>

<!-- End ai2html - 2025-06-18 18:56 -->

<!-- Generated by ai2html v0.101.0 - 2025-06-18 18:56 -->
<!-- ai file: p3_irgc-ghadir.ai -->
<style lang="scss">
  #g-p3_irgc-ghadir-box,
  #g-p3_irgc-ghadir-box .g-artboard {
    margin: 0 auto;
  }
  #g-p3_irgc-ghadir-box p {
    margin: 0;
  }
  #g-p3_irgc-ghadir-box .g-aiAbs {
    position: absolute;
  }
  #g-p3_irgc-ghadir-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-p3_irgc-ghadir-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-p3_irgc-ghadir-box {
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-p3_irgc-ghadir-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-p3_irgc-ghadir-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-p3_irgc-ghadir-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-p3_irgc-ghadir-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-p3_irgc-ghadir-xl {
        display: block !important;
      }
    }
  }
  #g-p3_irgc-ghadir-xs {
    position: relative;
    overflow: hidden;
  }
  #g-p3_irgc-ghadir-xs p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_irgc-ghadir-xs .g-pstyle0 {
    height: 21px;
  }
  #g-p3_irgc-ghadir-xs .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p3_irgc-ghadir-xs .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_irgc-ghadir-xs .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p3_irgc-ghadir-sm {
    position: relative;
    overflow: hidden;
  }
  #g-p3_irgc-ghadir-sm p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_irgc-ghadir-sm .g-pstyle0 {
    height: 21px;
  }
  #g-p3_irgc-ghadir-sm .g-pstyle1 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
  }
  #g-p3_irgc-ghadir-sm .g-pstyle2 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    letter-spacing: 0.2em;
    font-size: 12px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_irgc-ghadir-sm .g-pstyle3 {
    font-weight: 400;
    line-height: 14px;
    height: 14px;
    font-size: 12px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p3_irgc-ghadir-md {
    position: relative;
    overflow: hidden;
  }
  #g-p3_irgc-ghadir-md p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 700;
    line-height: 21px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 20px;
    text-align: left;
    color: rgb(0, 0, 0);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_irgc-ghadir-md .g-pstyle0 {
    height: 21px;
  }
  #g-p3_irgc-ghadir-md .g-pstyle1 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
  }
  #g-p3_irgc-ghadir-md .g-pstyle2 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    letter-spacing: 0.2em;
    font-size: 14px;
    text-align: center;
    color: rgb(122, 122, 122);
  }
  #g-p3_irgc-ghadir-md .g-pstyle3 {
    font-weight: 400;
    line-height: 17px;
    height: 17px;
    font-size: 14px;
    text-align: center;
    color: rgb(255, 255, 255);
  }
  #g-p3_irgc-ghadir-lg {
    position: relative;
    overflow: hidden;
  }
  #g-p3_irgc-ghadir-lg p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_irgc-ghadir-lg .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-p3_irgc-ghadir-lg .g-pstyle1 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-p3_irgc-ghadir-lg .g-pstyle2 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }
  #g-p3_irgc-ghadir-xl {
    position: relative;
    overflow: hidden;
  }
  #g-p3_irgc-ghadir-xl p {
    font-family: 'Knowledge', 'Source Sans Pro', Arial, sans-serif;
    font-weight: 400;
    line-height: 18px;
    height: auto;
    opacity: 1;
    padding-bottom: 0;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-p3_irgc-ghadir-xl .g-pstyle0 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 16px;
  }
  #g-p3_irgc-ghadir-xl .g-pstyle1 {
    height: 18px;
    padding-bottom: 9px;
  }
  #g-p3_irgc-ghadir-xl .g-pstyle2 {
    height: 18px;
    padding-bottom: 9px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  .g-text {
  }
</style>
